// extracted by mini-css-extract-plugin
export default {"footerText":"Footer_footerText__rlW5Y"};